import {
  ACCOUNT_PURPOSE,
  ACTIVE_ENTITY_CRITERION,
  ACTIVITY_BAND,
  BENEFICIAL_OWNER_TYPE,
  BUSINESS_SIZE_BAND,
  BUSINESS_SUB_TYPE,
  BUSINESS_TYPE,
  CONTROLLING_PERSON_TYPE,
  CONTROLLING_PERSON_TYPES_BY_ENTITY_KIND,
  EDD_CATEGORY,
  EMIR_CLASSIFICATION,
  EMPLOYEE_BAND,
  ENTITY_CLASSIFICATION,
  ESMA_CLASSIFICATION,
  EXCLUDED_PERSON_TYPE,
  FINANCIAL_ORGANISATION_TYPE,
  FUNDS_OWNERSHIP,
  LEGAL_FORM,
  LEGAL_PERSON_LEGAL_FORMS,
  LICENCE_COPY_SOURCE,
  LISTED_CORPORATION_RELATIONSHIP,
  MANAGEMENT_ROLE,
  NACE_CLASSIFICATION,
  NO_TIN_REASON,
  ORGANISATION_TYPE,
  OWNERSHIP_TYPE,
  PROHIBITED_CATEGORY,
  REGULATED_MARKET_LISTING,
  SCREENING_FREQUENCY,
  SOURCE_OF_FUNDS,
  TRADING_VOLUME_BAND,
} from '@1trading/fast-api-domain/forms';

import type { ValueOf } from '@/types/generics';

export { BUSINESS_SUB_TYPES_BY_BUSINESS_TYPE } from '@1trading/fast-api-domain/forms';

export const BusinessType = BUSINESS_TYPE;
export type BusinessType = ValueOf<typeof BusinessType>;
export const BUSINESS_TYPES = Object.values(BusinessType);

export const BusinessSubType = BUSINESS_SUB_TYPE;
export type BusinessSubType = ValueOf<typeof BusinessSubType>;
export const BUSINESS_SUB_TYPES = Object.values(BusinessSubType);

export const LegalForm = LEGAL_FORM;
export type LegalForm = ValueOf<typeof LegalForm>;
export const LEGAL_FORMS = Object.values(LegalForm);

export const ControlType = {
  INDIVIDUAL: 'INDIVIDUAL',
  ALGORITHM: 'ALGORITHM',
} as const;
export type ControlType = ValueOf<typeof ControlType>;
export const CONTROL_TYPES = Object.values(ControlType);

export const OrganisationType = ORGANISATION_TYPE;
export type OrganisationType = ValueOf<typeof OrganisationType>;
export const ORGANISATION_TYPES = Object.values(OrganisationType);

export const ORGANISATION_TYPES_REGULATED_FINANCIAL_SERVICES = [
  OrganisationType.CREDIT_INSTITUTION,
  OrganisationType.INVESTMENT_FIRM,
  OrganisationType.OTHER_AUTHORISED_OR_REGULATED_FINANCIAL_INSTITUTION,
  OrganisationType.INSURANCE_COMPANY,
] as const;

export type OrganisationTypeRegulatedFinancialServices = (typeof ORGANISATION_TYPES_REGULATED_FINANCIAL_SERVICES)[number];

export const FinancialOrganisationType = FINANCIAL_ORGANISATION_TYPE;
export type FinancialOrganisationType = ValueOf<typeof FinancialOrganisationType>;
export const FINANCIAL_ORGANISATION_TYPES = Object.values(FinancialOrganisationType);

export const EmirClassification = EMIR_CLASSIFICATION;
export type EmirClassification = ValueOf<typeof EmirClassification>;
export const EMIR_CLASSIFICATIONS = Object.values(EmirClassification);

export const EsmaClassification = ESMA_CLASSIFICATION;
export type EsmaClassification = ValueOf<typeof EsmaClassification>;
export const ESMA_CLASSIFICATIONS = Object.values(EsmaClassification);

export const NaceClassification = NACE_CLASSIFICATION;
export type NaceClassification = ValueOf<typeof NaceClassification>;
export const NACE_CLASSIFICATIONS = Object.values(NaceClassification);

export const EmirThreshold = {
  ABOVE: 'ABOVE',
  BELOW: 'BELOW',
} as const;
export type EmirThreshold = ValueOf<typeof EmirThreshold>;
export const EMIR_THRESHOLDS = Object.values(EmirThreshold);

export const BusinessSizeBand = BUSINESS_SIZE_BAND;
export type BusinessSizeBand = ValueOf<typeof BusinessSizeBand>;
export const BUSINESS_SIZE_BANDS = Object.values(BusinessSizeBand);

export const EmployeeBand = EMPLOYEE_BAND;
export type EmployeeBand = ValueOf<typeof EmployeeBand>;
export const EMPLOYEE_BANDS = Object.values(EmployeeBand);

export const FundsOwnership = FUNDS_OWNERSHIP;
export type FundsOwnership = ValueOf<typeof FundsOwnership>;
export const FUNDS_OWNERSHIPS = Object.values(FundsOwnership);

export const LicenceCopySource = LICENCE_COPY_SOURCE;
export type LicenceCopySource = ValueOf<typeof LicenceCopySource>;
export const LICENCE_COPY_SOURCES = Object.values(LicenceCopySource);

export const RegulatedMarketListing = REGULATED_MARKET_LISTING;
export type RegulatedMarketListing = ValueOf<typeof RegulatedMarketListing>;
export const REGULATED_MARKET_LISTINGS = Object.values(RegulatedMarketListing);

export const OwnershipType = OWNERSHIP_TYPE;
export type OwnershipType = ValueOf<typeof OwnershipType>;
export const OWNERSHIP_TYPES = Object.values(OwnershipType);

export const BeneficialOwnerType = BENEFICIAL_OWNER_TYPE;
export type BeneficialOwnerType = ValueOf<typeof BeneficialOwnerType>;

export const ManagementRole = MANAGEMENT_ROLE;
export type ManagementRole = ValueOf<typeof ManagementRole>;
export const MANAGEMENT_ROLES = Object.values(ManagementRole);

export const ScreeningFrequency = SCREENING_FREQUENCY;
export type ScreeningFrequency = ValueOf<typeof ScreeningFrequency>;
export const SCREENING_FREQUENCIES = Object.values(ScreeningFrequency);

export const EddCategory = EDD_CATEGORY;
export type EddCategory = ValueOf<typeof EddCategory>;
export const EDD_CATEGORIES = Object.values(EddCategory);

export const ProhibitedCategory = PROHIBITED_CATEGORY;
export type ProhibitedCategory = ValueOf<typeof ProhibitedCategory>;
export const PROHIBITED_CATEGORIES = Object.values(ProhibitedCategory);

export const ActivityBand = ACTIVITY_BAND;
export type ActivityBand = ValueOf<typeof ActivityBand>;
export const ACTIVITY_BANDS = Object.values(ActivityBand);

export const TradingVolumeBand = TRADING_VOLUME_BAND;
export type TradingVolumeBand = ValueOf<typeof TradingVolumeBand>;
export const TRADING_VOLUME_BANDS = Object.values(TradingVolumeBand);

export const AccountPurpose = ACCOUNT_PURPOSE;
export type AccountPurpose = ValueOf<typeof AccountPurpose>;
export const ACCOUNT_PURPOSES = Object.values(AccountPurpose);

export const SourceOfFunds = SOURCE_OF_FUNDS;
export type SourceOfFunds = ValueOf<typeof SourceOfFunds>;
export const SOURCES_OF_FUNDS = Object.values(SourceOfFunds);

export const NoTinReason = NO_TIN_REASON;
export type NoTinReason = ValueOf<typeof NoTinReason>;
export const NO_TIN_REASONS = Object.values(NoTinReason);

export const ExcludedPersonType = EXCLUDED_PERSON_TYPE;
export type ExcludedPersonType = ValueOf<typeof ExcludedPersonType>;
export const EXCLUDED_PERSON_TYPES = Object.values(ExcludedPersonType);

export const ListedCorporationRelationship = LISTED_CORPORATION_RELATIONSHIP;
export type ListedCorporationRelationship = ValueOf<typeof ListedCorporationRelationship>;
export const LISTED_CORPORATION_RELATIONSHIPS = Object.values(ListedCorporationRelationship);

export const EntityClassification = ENTITY_CLASSIFICATION;
export type EntityClassification = ValueOf<typeof EntityClassification>;
export const ENTITY_CLASSIFICATIONS = Object.values(EntityClassification);

export const ActiveEntityCriterion = ACTIVE_ENTITY_CRITERION;
export type ActiveEntityCriterion = ValueOf<typeof ActiveEntityCriterion>;
export const ACTIVE_ENTITY_CRITERIA = Object.values(ActiveEntityCriterion);

export const ControllingPersonType = CONTROLLING_PERSON_TYPE;
export type ControllingPersonType = ValueOf<typeof ControllingPersonType>;
export const CONTROLLING_PERSON_TYPES = Object.values(ControllingPersonType);

export { CONTROLLING_PERSON_TYPES_BY_ENTITY_KIND, LEGAL_PERSON_LEGAL_FORMS };
export type EntityKind = keyof typeof CONTROLLING_PERSON_TYPES_BY_ENTITY_KIND;
export const ENTITY_KINDS = Object.keys(CONTROLLING_PERSON_TYPES_BY_ENTITY_KIND) as EntityKind[];
